/**
 * Featured / UTM product spotlighting on the collection page (PLP).
 *
 * Reads a `?featured=` query parameter containing a comma-separated list of product
 * handles and moves/injects those products to the top of the collection grid, so shoppers
 * arriving from an ad/email/influencer link see the advertised products first — without a
 * dedicated landing page.
 *
 *   /collections/<handle>?featured=handle-1,handle-2,handle-3
 *
 * - If a product is already on the current page, its existing (already hydrated) card is
 *   moved to the front — no fetch.
 * - If a product is not on the current page, its card is fetched by handle via the Section
 *   Rendering API (`/products/<handle>?section_id=featured-product-card`) and injected, then
 *   its swatches + mobile carousel are hydrated.
 *
 * Applies on initial landing only. Once the shopper filters/sorts (which re-renders the
 * grid via facets.js), normal behaviour takes over.
 */
(function () {
  var PARAM = 'featured';
  var MAX_PRODUCTS = 3;
  var SECTION_ID = 'featured-product-card';
  var applied = false;

  function getHandles() {
    var raw = new URLSearchParams(window.location.search).get(PARAM);
    if (!raw) return [];

    var seen = {};
    var handles = raw
      .split(',')
      .map(function (handle) {
        return handle.trim();
      })
      .filter(function (handle) {
        if (!handle || seen[handle]) return false;
        seen[handle] = true;
        return true;
      });

    if (handles.length > MAX_PRODUCTS) {
      console.log(
        '[featured-products] ' +
          handles.length +
          ' handles provided; only the first ' +
          MAX_PRODUCTS +
          ' will be spotlighted.'
      );
    }

    return handles.slice(0, MAX_PRODUCTS);
  }

  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function findCardInGrid(grid, handle) {
    return grid.querySelector('.ProductItem[data-handle="' + (window.CSS ? CSS.escape(handle) : handle) + '"]');
  }

  // Resolve a handle to a card node: move an existing one, or fetch a fresh one.
  function resolveNode(grid, handle) {
    var existing = findCardInGrid(grid, handle);
    if (existing) {
      return Promise.resolve({ node: existing, fetched: false });
    }

    var url = getRoot() + 'products/' + encodeURIComponent(handle) + '?section_id=' + SECTION_ID;

    return fetch(url)
      .then(function (response) {
        if (!response.ok) return null; // invalid/unknown handle -> 404
        return response.text();
      })
      .then(function (html) {
        if (!html) return null;
        var card = new DOMParser().parseFromString(html, 'text/html').querySelector('.ProductItem');
        return card ? { node: card, fetched: true } : null;
      })
      .catch(function () {
        return null;
      });
  }

  function hydrateFetchedCard(node) {
    if (typeof window.hydrateProductCardSwatches === 'function') {
      window.hydrateProductCardSwatches(node);
    }
    if (window.jQuery) {
      window
        .jQuery(node)
        .find('.mobile-image-carousel')
        .slick({ dots: true, arrows: false, infinite: false });
    }
  }

  function refreshMovedCard(node) {
    if (!window.jQuery) return;
    var $carousel = window.jQuery(node).find('.mobile-image-carousel');
    if ($carousel.length && $carousel.hasClass('slick-initialized')) {
      $carousel.slick('setPosition');
    }
  }

  // Remove any stray duplicate of a handle, keeping the front-most (spotlighted) one.
  function dedupe(grid, handle) {
    var matches = grid.querySelectorAll(
      '.ProductItem[data-handle="' + (window.CSS ? CSS.escape(handle) : handle) + '"]'
    );
    for (var i = 1; i < matches.length; i++) {
      matches[i].remove();
    }
  }

  function apply() {
    if (applied) return;
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var handles = getHandles();
    if (!handles.length) return;
    applied = true;

    Promise.all(
      handles.map(function (handle) {
        return resolveNode(grid, handle);
      })
    ).then(function (results) {
      var fragment = document.createDocumentFragment();
      var fetched = [];
      var moved = [];

      results.forEach(function (result) {
        if (!result) return;
        fragment.appendChild(result.node); // moving a node here detaches it from its old spot
        if (result.fetched) {
          fetched.push(result.node);
        } else {
          moved.push(result.node);
        }
      });

      if (!fragment.childNodes.length) return;

      grid.prepend(fragment);

      fetched.forEach(hydrateFetchedCard);
      moved.forEach(refreshMovedCard);
      handles.forEach(function (handle) {
        dedupe(grid, handle);
      });
    });
  }

  if (typeof window.deferjQuery === 'function') {
    window.deferjQuery(function () {
      window.jQuery(document).ready(apply);
    });
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
